import * as pbi from 'powerbi-client'

export default {
  methods: {
    loadDashboard (embedUrl, accessToken) {
      const config = {
        type: 'report',
        tokenType: pbi.models.TokenType.Embed,
        accessToken: accessToken,
        embedUrl: embedUrl
      }

      const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory)
      const reportContainer = document.getElementById('report-container')
      const report = powerbi.embed(reportContainer, config)

      report.off('loaded')

      report.off('rendered')

      report.on('error', () => {
        this.report.off('error')
        throw new Error('Erro ao carregar!')
      })
    }
  }
}
